import { extendTailwindMerge } from 'tailwind-merge';

export const twMerge = extendTailwindMerge({
  separator: '_',
  classGroups: { 'bg-color': [{ bg: ['bg-paper'] }] }
});

export default twMerge;
